import classnames from 'classnames'

import useStorefrontModeContext from '@src/quince-site-common/src/contexts/storefront-mode-context'
import Directory from '@src/quince-site-common/src/domains/Directory'
import { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import getB2BRoute from '@src/quince-site-common/src/utils/b2b/get-b2b-route'

import Link from '../link'
import { Skeleton } from '../skeleton'

import styles from './breadCrumb.module.scss'

const TRACKING_CONFIG = {
  CATEGORY: 'navigation',
  ACTION: 'click_bread_crumb',
} as const

interface BreadcrumbsProps {
  directory: Directory
  breadCrumbListClass?: string
  isNewCLPFiltersExperimentActive?: boolean
  deviceType?: string
  showLoader?: boolean
  alignCenter?: boolean
  showNewPdpDesignV2?: boolean
}

const Breadcrumbs = ({
  directory,
  breadCrumbListClass,
  isNewCLPFiltersExperimentActive,
  deviceType,
  showLoader,
  alignCenter = false,
}: BreadcrumbsProps) => {
  const { isB2BMode } = useStorefrontModeContext()

  const getBreadcrumbItemClasses = (index: number) => {
    const isFirstPath = index === 0
    const isDesktop = deviceType === DEVICE_TYPES.DESKTOP

    const experimentClasses =
      isNewCLPFiltersExperimentActive && isDesktop
        ? classnames(styles.newCLPFiltersExperiment, isFirstPath && styles.newCLPFiltersExperimentFirstPath)
        : ''

    return classnames(styles.breadCrumbPage, experimentClasses, isFirstPath && styles.firstPath)
  }

  if (showLoader) {
    return <Skeleton className={styles.breadCrumbLoader} />
  }

  return (
    <ol className={classnames(styles.breadCrumbList, breadCrumbListClass, alignCenter && styles.centered)}>
      {directory.paths.map((path, index) => {
        const isLastPath = index === directory.paths.length - 1

        if (isLastPath) {
          return (
            <li className={getBreadcrumbItemClasses(index)} key={path.route}>
              <span className={styles.breadCrumbText}>{path.displayName}</span>
            </li>
          )
        }

        return (
          <li className={getBreadcrumbItemClasses(index)} key={`${path.route}${index}`}>
            <Link
              className={classnames(styles.breadCrumbLink, styles.breadCrumbButton)}
              href={isB2BMode ? getB2BRoute(path.route) : path.route}
              trackConfig={{
                trackInternal: true,
                category: TRACKING_CONFIG.CATEGORY,
                action: TRACKING_CONFIG.ACTION,
                label: path.displayName,
                value: path.route,
              }}
            >
              {path.displayName}
            </Link>
            <span>/</span>
          </li>
        )
      })}
    </ol>
  )
}

export default Breadcrumbs
